module.exports = __webpack_public_path__ + "/img/SOD-YpIWGb.svg";